<template>
  <page>
    <ZuiHeader />
    <SubPageTemplate page-title="精彩体验" dynamically-tab :pid="pid" type="experience" :pageNav="false"></SubPageTemplate>
    <ZuiFooter />
  </page>
</template>
<script>
import SubPageTemplate from "~/components/template/SubPageTemplate.vue";
export default {
  components: {
    SubPageTemplate
  },
  data() {
    return {
      pid: '20'
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/list.vue